const cards = [
  {
    title: '久久视频·资源指南',
    desc: '久久视频在线视频网站完整使用指南，涵盖视频播放器在线看视频所有入口与使用技巧。',
    img: 'https://readdy.ai/api/search-image?query=Warm%20abstract%20art%20with%20soft%20overlapping%20circles%2C%20amber%20and%20cream%20tones%2C%20modern%20minimal%20card%20design%2C%20no%20text%2C%20clean%20aesthetic%2C%20guide%20theme&width=640&height=440&seq=card-01&orientation=landscape',
    date: '2026-07-28',
    tag: '资源指南',
  },
  {
    title: '芒果视频·最新动态',
    desc: '芒果视频平台近期更新内容汇总，视频播放器在线看视频功能优化与新增资源介绍。',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20warm%20gradient%20with%20geometric%20patterns%2C%20terracotta%20and%20beige%20tones%2C%20modern%20card%20layout%2C%20no%20text%2C%20news%20theme%2C%20clean%20composition&width=640&height=440&seq=card-02&orientation=landscape',
    date: '2026-07-26',
    tag: '平台动态',
  },
  {
    title: '97视频·访问指南',
    desc: '97视频在线视频网站多通道访问方案，确保视频播放器在线看视频的稳定可靠体验。',
    img: 'https://readdy.ai/api/search-image?query=Minimal%20warm%20abstract%20design%20with%20flowing%20lines%2C%20coral%20and%20cream%20gradient%2C%20modern%20card%20aesthetic%2C%20no%20text%2C%20access%20theme%2C%20clean%20look&width=640&height=440&seq=card-03&orientation=landscape',
    date: '2026-07-24',
    tag: '访问指南',
  },
  {
    title: '丝瓜视频·精选推荐',
    desc: '丝瓜视频在线视频网站精品内容精选，为您推荐视频播放器在线看视频的优质资源。',
    img: 'https://readdy.ai/api/search-image?query=Soft%20warm%20abstract%20pattern%2C%20peach%20and%20gold%20tones%2C%20modern%20minimal%20card%2C%20no%20text%2C%20recommendation%20theme%2C%20clean%20aesthetic&width=640&height=440&seq=card-04&orientation=landscape',
    date: '2026-07-22',
    tag: '精选推荐',
  },
  {
    title: '蓝莓视频·新手指南',
    desc: '蓝莓视频在线视频网站新手指南，帮助新用户快速上手视频播放器在线看视频功能。',
    img: 'https://readdy.ai/api/search-image?query=Gentle%20warm%20abstract%20composition%2C%20soft%20amber%20and%20cream%2C%20modern%20guide%20card%2C%20no%20text%2C%20beginner%20theme%2C%20clean%20design&width=640&height=440&seq=card-05&orientation=landscape',
    date: '2026-07-20',
    tag: '新手指南',
  },
  {
    title: '在线视频网站·安全须知',
    desc: '使用视频播放器在线看视频时的安全注意事项，保障您在国产91视频平台的安全浏览体验。',
    img: 'https://readdy.ai/api/search-image?query=Warm%20abstract%20shield%20like%20shapes%2C%20amber%20and%20terracotta%20tones%2C%20modern%20security%20theme%20card%2C%20no%20text%2C%20clean%20composition&width=640&height=440&seq=card-06&orientation=landscape',
    date: '2026-07-18',
    tag: '安全须知',
  },
  {
    title: '视频播放器·使用技巧',
    desc: '提升视频播放器在线看视频体验的实用技巧，包括播放设置、网络优化与资源管理建议。',
    img: 'https://readdy.ai/api/search-image?query=Modern%20warm%20abstract%20design%20with%20play%20button%20shapes%2C%20crimson%20and%20gold%2C%20tips%20card%20theme%2C%20no%20text%2C%20clean%20aesthetic&width=640&height=440&seq=card-07&orientation=landscape',
    date: '2026-07-16',
    tag: '使用技巧',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading text-center mb-4">
          资源指南
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-12 max-w-lg mx-auto">
          国产91视频为您整理的在线视频网站使用指南与视频播放器在线看视频实用内容
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {cards.slice(0, 7).map((item, i) => (
            <div key={i} className={`group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200/60 transition-all cursor-pointer ${
              i === 6 ? 'sm:col-span-2 lg:col-span-3 xl:col-span-1' : ''
            }`}>
              <div className="relative w-full aspect-[3/2] overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-2.5 py-1 rounded-md bg-background-50/90 text-xs font-medium text-primary-600 whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <span className="text-xs text-foreground-400 block mb-2">{item.date}</span>
                <h3 className="text-sm font-bold text-foreground-800 mb-2 group-hover:text-primary-600 transition-colors">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}